const fetchStatus = {
  idle: 'idle',
  fetching: 'fetching',
}

export default fetchStatus

export { fetchStatus }
